import { Badge } from './Badge';
import type { ExecutionStatus } from '@databro/shared';

interface StatusBadgeProps {
  status: ExecutionStatus | 'idle' | 'needs_auth' | 'ready';
  className?: string;
}

const statusConfig: Record<string, { variant: 'success' | 'destructive' | 'warning' | 'secondary' | 'default'; label: string }> = {
  success: { variant: 'success', label: 'Success' },
  failed: { variant: 'destructive', label: 'Failed' },
  running: { variant: 'warning', label: 'Running' },
  queued: { variant: 'warning', label: 'Queued' },
  pending: { variant: 'secondary', label: 'Pending' },
  auth_required: { variant: 'destructive', label: 'Auth Required' },
  waiting_for_client: { variant: 'warning', label: 'Waiting for Client' },
  cancelled: { variant: 'secondary', label: 'Cancelled' },
  needs_auth: { variant: 'destructive', label: 'Needs Auth' },
  idle: { variant: 'secondary', label: 'Idle' },
  ready: { variant: 'success', label: 'Ready' },
};

export function StatusBadge({ status, className }: StatusBadgeProps) {
  const config = statusConfig[status] || { variant: 'secondary' as const, label: status };

  return (
    <Badge variant={config.variant} className={className}>
      {config.label}
    </Badge>
  );
}
